import React, {Component} from 'react';
import UploadContainer from './Upload/UploadContainer';
import ModelContainer from './Models/ModelContainer';
import ResultsContainer from './Results/ResultsContainer';
import ConsentDialog from './ConsentDialog';

import { 
    Button,
    CircularProgress,
    Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, 
    IconButton,
    Snackbar, SnackbarContent, 
    Step, StepConnector, StepContent, StepLabel, Stepper,
    Typography,
    withStyles,
} from '@material-ui/core';
import styles from './Home.css';
import CloseIcon from '@material-ui/icons/Close';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import {withRouter} from 'react-router-dom';
import classNames from 'classnames';
import {JOB_STATUS_EDITING, 
        IMAGE_STATUS_EDITING, 
        JOB_STATUS_FINISHED,
        JOB_STATUS_STARTED,
        JOB_STATUS_SUBMITTED
} from '../../constants';
import * as serverAPI from '../../client';
import axios from 'axios';
import Cookies from 'js-cookie';

axios.defaults.withCredentials = true;
axios.defaults.baseURL = '/api';

class Home extends Component {

    constructor(props) {
        super(props);
        this.state = this.initialState;
    }

    get initialState() {
        return {
            files: [],
            selectedModel: 0,
            activeStep: 0,
            cellSize: 20,
            jobStatus: JOB_STATUS_EDITING,
            resultsDownloaded: false,
            uploadSnackBarOpen: false,
            message: {
                dialogOpen: false,
                message: '',
                status: ''
            },
            warning: {
                warningSnackBarOpen: false,
                message: ''
            },
            serverParams: {
                imageLimit: 20,
                secondsUntilNextSubmit: 0
            },
            resetWarningDialogOpen: false,
            error: null,
            resultsLoading: false,
            results: [],
            resultsLightBoxOpen: false,
            resultIndexToShow: 0,
            loadingOnSubmit: false,
            editable: true,

            arePoliciesAccepted: Cookies.get('arePoliciesAccepted')?JSON.parse(Cookies.get('arePoliciesAccepted')):''
        }
    }

    async componentDidMount() {
        let params = await serverAPI.getServerParams()
            .catch( error => {
                this.setState({
                    error: error
                });
                this.popupError(error);
            });

        if (params) {
            this.startSessionTimer();
            this.setState({
                serverParams: params,
                error: null
            });
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timer);
        clearTimeout(this.sessionTimer);
    }

    handleCloseUploadSnackBar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ 
            uploadSnackBarOpen: false 
        });
    }

    handleOpenUploadSnackBar = () => {
        this.setState({
            uploadSnackBarOpen: true
        });
    }

    handleCloseMessageDialog = () => {
        this.setState( { 
            message: {
                dialogOpen: false,
                message: '',
                status: ''
            }
        });
    }

    handleOpenMessageDialog = () => {
        this.setState({
            message: {
                dialogOpen: true
            }
        });
    }

    popupError = (error) => {
        let message;
        if (!error.response) {
            message = 'Error while communicating with the server: ' + error.message;
        } else {
            if (error.response.status>=500){
                message = 'Server error: ' + error.message;
            } else if(error.response.status===404){
                message = 'Server error: ' + error.message;
            } else {
                message = error.response.data;
            }
        }
        this.setLastMessage("Error", message);
    }

    setLastMessage = (status, message) => {
        this.setState({
            message: {
                dialogOpen: true,
                message: message,
                status: status
            }
        });
    }

    popupWarningSnackBar = (message) => {
        this.setState({
            warning: {
                warningSnackBarOpen: true,
                message: message
            }
        });
    }

    handleCloseWarningSnackBar = () => {
        this.setState({
            warning: {
                warningSnackBarOpen: false,
                message: ''
            }
        });
    }

    handleUploadNext = () => {
        this.setState(prevState => ({
            activeStep: prevState.activeStep + 1
        }));
    };

    handleModelBack = () => {
        this.setState(prevState => ({
            activeStep: prevState.activeStep - 1,
        }));
    };

    handleModelNext = async () => {
        const files = this.state.files;
        this.setState({
            loadingOnSubmit: true,
            editable: false
        });

        if (this.state.serverParams.imageLimit < files.length) {
            this.setLastMessage("Error", "Too many images! You tried to upload " + files.length +" images. You can upload only " + this.state.serverParams.imageLimit + " images in batch.");
            this.setState({loadingOnSubmit: false, editable: true});
        } else if (this.state.serverParams.secondsUntilNextSubmit>0) {
            serverAPI.submit(this.state.selectedModel, this.state.cellSize)
                .catch( error => {
                    this.setState({loadingOnSubmit: false, editable: true});
                    this.popupError(error);
                });
        } else {
            await serverAPI.reset()
                .catch( error => {
                    this.setState({loadingOnSubmit: false, editable: true});
                    this.popupError(error);
                });

            // TODO: local sessiontimer check
            let list = await serverAPI.addAll(files);
            Promise
                .all(list)
                .then( res => {
                    this.handleOpenUploadSnackBar();

                    serverAPI.submit(this.state.selectedModel, this.state.cellSize)
                        .then( result => {
                            this.setJobStatus(JOB_STATUS_SUBMITTED);
                            this.startTimer();
                            this.setState({
                                timestamp: new Intl.DateTimeFormat('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'}).format(Date.now())
                            });
                            this.setState(prevState => ({
                                activeStep: prevState.activeStep + 1,
                                resultsLoading: true,
                                loadingOnSubmit: false
                            }));
                        })
                        .catch( error => {
                            this.setState({loadingOnSubmit: false, editable: true});
                            this.popupError(error);
                        });                    
                }).catch( error => {
                    this.setState({loadingOnSubmit: false, editable: true});
                    this.popupError(error);
                });
        }
            
    };

    startSessionTimer = () => {
        this.sessionTimer = setInterval( () => this.countDown(), 1000);
    }

    countDown = () => {
        this.setState( (prevState) => ({
            ...prevState,
            serverParams: {
                ...prevState.serverParams,
                secondsUntilNextSubmit: prevState.serverParams.secondsUntilNextSubmit-1 > 0
                                        ? prevState.serverParams.secondsUntilNextSubmit - 1
                                        : 0
            }
        }));
    }

    startTimer = () => {
        this.timer = setInterval(() => this.getResult(), 5000);
    }
    
    getResult = async () => {
        this.setState({
            timestamp: new Intl.DateTimeFormat('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'}).format(Date.now())
        });
        serverAPI.getResult()
            .then( result => {
                // TODO set results list
                // TODO: handle job started state
                /* if (result.data.result==="STARTED"){
                    results.data.images.forEach( (image) => {
                        
                    });
                } */

                // TODO: timer display???
                // console.log(result);
                if (result.data.result==="STARTED") {
                    this.setJobStatus(JOB_STATUS_STARTED);
                } if (result.data.result==="FINISHED") {
                    clearTimeout(this.timer);
                    this.setJobStatus(JOB_STATUS_FINISHED);
                    this.setState({
                        resultsLoading: false
                    });

                    result.data.images.forEach( (image) => {
                        if (null == image.errorMessage) {
                            serverAPI.getResultImage(image.id)
                                .then( resultImage => {
                                    let srcValue = URL.createObjectURL(resultImage.data);
                                    this.setState( (prevState) => (
                                        {
                                            results: [
                                                ...prevState.results, 
                                                {
                                                    name: image.originalFilename, 
                                                    id: image.id, 
                                                    src: srcValue
                                                }
                                            ]
                                        }
                                    ))
                                }).catch( error => {
                                    this.setState( (prevState) => (
                                        {
                                            results: [
                                                ...prevState.results, 
                                                {
                                                    name: 'Error while downloading result image for: ' + image.originalFilename, 
                                                    id: image.id, 
                                                    src: process.env.PUBLIC_URL + '/images/image-not-available2.png'
                                                }
                                            ]
                                        }
                                    ))
                                });
                        } else {
                            this.setState( (prevState, props) => (
                                {
                                    results: [
                                        ...prevState.results, 
                                        {
                                            name: 'Processing failed for: ' + image.originalFilename + '. Error message: ' + image.errorMessage, 
                                            id: image.id, 
                                            src: process.env.PUBLIC_URL + '/images/image-not-available2.png'
                                        }
                                    ]
                                }
                            ))
                        }
                    });

                } 
            }
            );
    }

    handleReset = async () => {
        clearTimeout(this.timer);
        let params = await serverAPI.getServerParams()
            .catch( error => {
                this.setState({
                    error: error
                });
                this.popupError(error);
            });

        this.setState( {
            ...this.initialState
        } );

        if (params) {
            this.startSessionTimer();
            this.setState({
                serverParams: params,
                error: null
            });
        }
    };

    handleCloseResetWarningDialog = () => {
        this.setState({
            resetWarningDialogOpen: false
        });
    }

    handleOpenResetWarningDialog = () => {
        // TODO: set downloadSuccess
        if (!this.state.resultsDownloaded){
            this.setState({
                resetWarningDialogOpen: true
            });
        } else {
            this.handleReset();
        }
    }

  
    removeFileFromList = (fileName) => {
        this.setState( prevState => ({
            files: prevState.files.filter( file => fileName!==file.name )
        }));
    }

    updateFilesList = (files) => {
        const fileNames = this.state.files.map( (file) => (file.name));
        const newFiles = files.filter( (file) => !fileNames.includes(file.name));
        newFiles.forEach(element => {
            element.status = IMAGE_STATUS_EDITING;
        });
        this.setState( prevState => (
            {
                files: [...prevState.files, ...newFiles]
            }
        ));
    }

    setSelectedModel = (modelId) => {
        this.setState( {
            selectedModel: modelId
        });
    }

    setJobStatus = (jobStatus) => {
        this.setState({
            jobStatus: jobStatus
        });
    }

    clearFilesList = async () => {
        await this.setState({
            files: []
        });
    }

    changeCellSize = (cellSize) => {
        this.setState({
            cellSize: cellSize
        });
    }

    validateUploadStep = () => {
        return this.state.files.length>0 && this.state.cellSize>=1 && this.state.cellSize<=300;
    }

    downloadResultZip = () => {
        serverAPI.downloadResultZip()
            .then( result => {
                this.setState({
                    resultsDownloaded: true
                })
            })
            .catch( error => {
                this.popupError(error);
            });
    }

    displayLightBox = (index) => {
        this.setState({
			resultsLightBoxOpen: true,
			resultIndexToShow: index
		});
    }

    saveConsentCookies = (value) => {
        this.setState({arePoliciesAccepted: value});
        Cookies.set('arePoliciesAccepted', JSON.stringify(value));
        if (!value){
            this.props.history.push("/gallery");
        }
    }

    render() {

        const { classes } = this.props;
        const {
            activeStep, 
            resultsLightBoxOpen, 
            resultIndexToShow, 
            results,
            loadingOnSubmit,
            cellSize,
            jobStatus,
            files
        } = this.state;

        const connector = (
            <StepConnector
                classes={{
                    active: classes.connectorActive,
                    completed: classes.connectorCompleted,
                    disabled: classes.connectorDisabled,
                    line: classes.connectorLine,
                }}
            />
        );

        return (
            <div className={classes.Home}>
                
                <div className={classes.stepperRoot}>
                    <Stepper 
                        activeStep={activeStep} 
                        orientation="vertical" 
                        connector={connector}
                        classes={{root: classes.stepper}}
                    >
                        <Step key='Upload images'>
                            <StepLabel>
                                <Typography variant="h6">Upload images</Typography>
                            </StepLabel>
                            <StepContent>
                                <UploadContainer
                                    updateFilesList={this.updateFilesList}
                                    clearFilesList={this.clearFilesList}
                                    files={files}
                                    removeFileFromList={this.removeFileFromList}
                                    editable={this.state.editable}
                                    cellSize={cellSize}
                                    changeCellSize={this.changeCellSize}
                                    popupWarningSnackBar={this.popupWarningSnackBar}
                                />
                                <div className={classes.actionsContainer}>
                                    <div>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={this.handleUploadNext}
                                            className={classes.button}
                                            disabled={!this.validateUploadStep()}
                                        >
                                            Next
                                        </Button>
                                    </div>
                                </div>
                            </StepContent>
                        </Step>

                        <Step key='Select the most similar image'>
                            <StepLabel>
                                <Typography variant="h6">Select the most similar image</Typography>
                            </StepLabel>
                            <StepContent>
                                <ModelContainer 
                                    submitAllowed={this.state.submitAllowed} 
                                    selectedModel={this.state.selectedModel}
                                    setSelectedModel={this.setSelectedModel}
                                    onUploadAndSubmit={this.onUploadAndSubmit}
                                    editable={this.state.editable}
                                />
                                <div className={classes.actionsContainer}>
                                    {/* <div> */}
                                        <Button
                                            disabled={activeStep === 0}
                                            onClick={this.handleModelBack}
                                            className={classNames(classes.button)}
                                        >
                                            Back
                                        </Button>
                                        <div className={classes.modelNextWrapper}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={this.handleModelNext}
                                                className={classes.button}
                                                // disabled={this.state.error}
                                                disabled={loadingOnSubmit}
                                            >
                                                Next
                                            </Button>
                                            {loadingOnSubmit && <CircularProgress size={24} className={classes.buttonProgress} />}
                                        </div>
                                    {/* </div> */}
                                </div>
                            </StepContent>
                        </Step>

                        <Step key='Get the results' className="resultsStepperStep">
                            <StepLabel completed={jobStatus===JOB_STATUS_FINISHED}>
                                <Typography variant="h6">Get the results</Typography>
                            </StepLabel>
                            <StepContent className="resultsStepContent">
                                <ResultsContainer 
                                    results={this.state.results} 
                                    selectedModel={this.state.selectedModel}
                                    setJobStatus={this.setJobStatus}
                                    handleOpenUploadSnackBar={this.handleOpenUploadSnackBar}
                                    cellSize={this.state.cellSize}
                                    jobStatus={this.state.jobStatus}
                                    setLastMessage={this.setLastMessage}
                                    downloadResultZip={this.downloadResultZip}
                                    loading={this.state.resultsLoading}
                                    displayLightBox={this.displayLightBox}
                                    timestamp={this.state.timestamp}
                                />
                                <div className={classes.actionsContainer}>
                                    <div>
                                        <Button 
                                            onClick={this.handleOpenResetWarningDialog} 
                                            className={classes.button}
                                        >
                                            Reset data
                                        </Button>
                                        <Button
                                            variant="contained" 
                                            color="primary" 
                                            onClick={this.downloadResultZip}
                                            className={classes.downloadButton} 
                                            disabled={results.length===0}
                                        > 
                                            Download
                                        </Button>
                                    </div>
                                </div>
                            </StepContent>
                        </Step>
                    </Stepper>
                </div>

                <Snackbar
                    open={this.state.uploadSnackBarOpen}
                    onClose={this.handleCloseUploadSnackBar}
                    autoHideDuration={3000}
                >
                    <SnackbarContent 
                        className={classes.uploadSuccess}
                        message="ALL IMAGES UPLOADED"
                        action={[
                            <IconButton
                                key="close"
                                aria-label="Close"
                                color="inherit"
                                onClick={this.handleCloseUploadSnackBar}
                            >
                                <CloseIcon />
                            </IconButton>
                        ]}
                    >
                    </SnackbarContent>
                </Snackbar>

                <Snackbar
                    open={this.state.warning.warningSnackBarOpen}
                    onClose={this.handleCloseWarningSnackBar}
                    autoHideDuration={5000}
                >
                    <SnackbarContent 
                        className={classes.warningSnackbar}
                        message={this.state.warning.message}
                        action={[
                            <IconButton
                                key="close"
                                aria-label="Close"
                                color="inherit"
                                onClick={this.handleCloseWarningSnackBar}
                            >
                                <CloseIcon />
                            </IconButton>
                        ]}
                    >
                    </SnackbarContent>
                </Snackbar>

                <Dialog
                    open={this.state.message.dialogOpen}
                    onClose={this.handleCloseMessageDialog}
                >
                    <DialogTitle>{this.state.message.status}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {this.state.message.message}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseMessageDialog} color="primary" autoFocus>
                            Got it
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={this.state.resetWarningDialogOpen}
                    onClose={this.handleCloseResetWarningDialog}
                    >
                    <DialogTitle id="alert-dialog-title">{"Are you sure you want to reset data?"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            By clicking Reset you agree that your current data will be lost. Please first download your segmentation results.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseResetWarningDialog} color="primary" autoFocus>
                            Cancel
                        </Button>
                        <Button onClick={this.handleReset} color="secondary" >
                            Reset
                        </Button>
                    </DialogActions>
                </Dialog>

                <ConsentDialog
                    open={this.state.arePoliciesAccepted!==true}
                    changeConsent={this.changeConsent}
                    saveConsentCookies={this.saveConsentCookies}
                    checked={this.state.arePoliciesAccepted===true}
                />

                { resultsLightBoxOpen && (
                <Lightbox
                    mainSrc={results[resultIndexToShow].src}
                    nextSrc={results[(resultIndexToShow + 1) % results.length].src}
                    prevSrc={results[(resultIndexToShow + results.length - 1) % results.length].src}
                    imageCaption={results[resultIndexToShow].name}
                    onCloseRequest={() => 
                        this.setState({ 
                            resultsLightBoxOpen: false 
                        })}
                    onMovePrevRequest={() =>
                        this.setState({
                            resultIndexToShow: (resultIndexToShow + results.length - 1) % results.length,
                        })
                    }
                    onMoveNextRequest={() =>
                        this.setState({
                            resultIndexToShow: (resultIndexToShow + 1) % results.length,
                        })
                    }
                />
                )}


            </div>
        );
    }
}

export default withRouter(withStyles(styles, {withTheme: true})(Home));
